// extracted by mini-css-extract-plugin
export var arrows = "_4k-5";
export var decrementer = "_4k-9";
export var disabled = "_4k-3";
export var error = "_4k-1";
export var hiddenText = "_4k-a";
export var incrementer = "_4k-8";
export var input = "_4k-7";
export var inputWrapper = "_4k-0";
export var readonly = "_4k-2";
export var regular = "_4k-6";
export var small = "_4k-4";